import { render, staticRenderFns } from "./AboutUs.vue?vue&type=template&id=2f41eee9"
import script from "./AboutUs.vue?vue&type=script&lang=js"
export * from "./AboutUs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/CoreProductivity.Backoffice.Mobile/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2f41eee9')) {
      api.createRecord('2f41eee9', component.options)
    } else {
      api.reload('2f41eee9', component.options)
    }
    module.hot.accept("./AboutUs.vue?vue&type=template&id=2f41eee9", function () {
      api.rerender('2f41eee9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/pages/profile/AboutUs.vue"
export default component.exports